(() => {
  'use strict';

  const PHONE_DISPLAY = '021-440 00 43';
  const PHONE_TEL = '+46214400043';
  const EMAIL = 'sales@paxkok.se';

  const productTitleFrom = (root) => {
    const title = root && root.querySelector('h1, .product-card__title, .pax-product-card h4, .pax-campaign-card__title');
    return title ? title.textContent.trim() : '';
  };

  const contactUrl = (title) => '/pages/contact?produkt=' + encodeURIComponent(title || '') + '#kontaktformular';

  const isZeroPriceText = (text) => {
    const value = String(text || '').replace(/\u00a0/g, ' ').trim().toLowerCase().replace(/\s+/g, '');
    return /^0(?:[,.]0{1,2})?(?:kr|sek)?$/.test(value);
  };

  const makeContact = (title, withButton = true) => {
    const wrap = document.createElement('div');
    wrap.className = 'pax-zero-contact';
    wrap.innerHTML = '<div class="pax-zero-contact__links">' +
      '<a class="pax-zero-contact__link" href="tel:' + PHONE_TEL + '"><span class="pax-zero-contact__label">Telefon</span>' + PHONE_DISPLAY + '</a>' +
      '<a class="pax-zero-contact__link" href="mailto:' + EMAIL + '"><span class="pax-zero-contact__label">E-post</span>' + EMAIL + '</a>' +
      '</div>' +
      (withButton ? '<a class="pax-zero-contact__button" href="' + contactUrl(title) + '">Öppna offertformulär</a>' : '');
    return wrap;
  };

  const enhanceStandardQuoteCards = () => {
    document.querySelectorAll('.product-card--quote').forEach((card) => {
      if (card.dataset.paxZeroReady === 'true') return;
      card.dataset.paxZeroReady = 'true';
      const title = productTitleFrom(card);
      const note = card.querySelector('.product-card__quote-note');
      if (note) note.textContent = 'För prisoffert, kontakta oss.';
      const actions = card.querySelector('.product-card__actions');
      if (actions) {
        actions.replaceChildren();
        actions.appendChild(makeContact(title, true));
      } else {
        const body = card.querySelector('.product-card__body') || card;
        body.appendChild(makeContact(title, true));
      }
    });
  };

  const enhanceProductQuote = () => {
    document.querySelectorAll('.pax-product-quote').forEach((box) => {
      if (box.dataset.paxZeroReady === 'true') return;
      box.dataset.paxZeroReady = 'true';
      const productRoot = box.closest('[data-pax-product], .pax-product-v4, .pkp') || document;
      const title = productTitleFrom(productRoot);
      const p = box.querySelector('p');
      if (p) p.textContent = 'För prisoffert, kontakta oss direkt via telefon, e-post eller formuläret.';
      const oldButton = box.querySelector('a.button, .pkp-quote__btn');
      if (oldButton) oldButton.remove();
      box.appendChild(makeContact(title, true));
    });
  };

  const zeroInlineMarkup = (title) => {
    const wrap = document.createElement('div');
    wrap.className = 'pax-zero-inline';
    wrap.innerHTML = '<div class="pax-zero-inline__price">Pris på förfrågan</div>' +
      '<div class="pax-zero-inline__links">' +
      '<a href="tel:' + PHONE_TEL + '">' + PHONE_DISPLAY + '</a>' +
      '<a href="mailto:' + EMAIL + '">' + EMAIL + '</a>' +
      '</div>' +
      '<a class="pax-zero-inline__button" href="' + contactUrl(title) + '">Begär offert</a>';
    return wrap;
  };

  const enhanceCategoryShowcase = () => {
    document.querySelectorAll('.pax-product-card').forEach((card) => {
      if (card.dataset.paxZeroReady === 'true') return;
      const price = card.querySelector('.pax-product-card__price-current');
      if (!price || !isZeroPriceText(price.textContent)) return;
      card.dataset.paxZeroReady = 'true';
      const title = productTitleFrom(card);
      const priceBox = card.querySelector('.pax-product-card__price');
      if (priceBox) priceBox.replaceWith(zeroInlineMarkup(title));
    });
  };

  const enhanceCampaignCards = () => {
    document.querySelectorAll('.pax-campaign-card').forEach((card) => {
      if (card.dataset.paxZeroReady === 'true') return;
      const price = card.querySelector('.pax-campaign-card__price');
      if (!price || !isZeroPriceText(price.textContent)) return;
      card.dataset.paxZeroReady = 'true';
      const title = productTitleFrom(card);
      const priceWrap = card.querySelector('.pax-campaign-card__price-wrap');
      if (priceWrap) priceWrap.replaceWith(zeroInlineMarkup(title));
      const existingButton = card.querySelector('.pax-campaign-card__button');
      if (existingButton) existingButton.remove();
    });
  };

  const prefillContactForm = () => {
    if (!location.pathname.includes('/pages/contact')) return;
    const params = new URLSearchParams(location.search);
    const product = params.get('produkt');
    if (!product) return;
    const reference = document.querySelector('[name="contact[Ordernummer / produkt / modell]"]');
    if (reference && !reference.value) reference.value = product;
    const subject = document.querySelector('[data-pax-contact-select]');
    if (subject) {
      const option = Array.from(subject.options).find((item) => item.value === 'Offert / Produktfråga');
      if (option) subject.value = option.value;
    }
  };

  const run = () => {
    enhanceStandardQuoteCards();
    enhanceProductQuote();
    enhanceCategoryShowcase();
    enhanceCampaignCards();
    prefillContactForm();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('pax:products-appended', run);
})();
